import { MessageType } from 'enums/MessageType';

/**
 * Client agent ID. This ID is assigned to outgoing messages from widget client.
 */
export const clientAgentId = '0';

/**
 * Technical agent ID. This ID is assigned to incoming technical messages which
 * are not displayed in history but contain commands or metadata.
 */
export const techAgentId = '-1';

/**
 * Mock agent ID. This agent always exists and can be used for tests and mocks.
 */
export const mockAgentId = '-2';

/**
 * How many miliseconds the user should wait before repeating history dump.
 *
 * 3_600_000 - 1 hour
 */
export const historyDumpCooldown = 3_600_000;

/**
 * Message types that need to be processed by the sharing subsystem with their
 * corresponding message texts that get displayed clientside in the chat.
 */
export const sharingMessages: Partial<Record<MessageType, string>> = {
    [MessageType.SharingRequest]: 'Сотрудник банка отправил запрос на демонстрацию экрана',
    [MessageType.SharingStart]: 'Вы начали демонстрацию экрана',
    [MessageType.SharingStop]: 'Вы завершили демонстрацию экрана',
    [MessageType.SharingRemoteViewStart]: 'Оператор начал просмотр экрана',
    [MessageType.SharingRemoteViewStop]: 'Оператор завершил просмотр экрана',
};

/**
 * How many milliseconds should pass before showing the bot reply loader
 */
export const botSlowReply = 2_000;

/**
 * How many milliseconds should pass before hiding the bot reply loader after it's shown
 */
export const botReplyDefaultTimeout = 20_000;
